import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'anchor-shared/lib/model/entity/user';
import { UserDAO } from '../../../../../core/services/dao/userDAO';

@Component({
  selector: 'app-edit-profile-photo',
  templateUrl: './edit-profile-photo.component.html',
  styleUrls: ['./edit-profile-photo.component.scss'],
})
export class EditProfilePhotoComponent implements OnInit, OnDestroy {
  model: User;

  constructor(private userDAO: UserDAO, private router: Router) {}

  ngOnInit() {
    this.model = this.userDAO.getCurrentUser();
  }

  ngOnDestroy(): void {}

  save() {
    this.router.navigate(['manage']);
  }
}
